import { View, Text } from "@react-pdf/renderer";

import { styles } from "../styles";

export function AdditionalInformation() {
  return (
    <View style={{ marginTop: 5, display: "flex", flexDirection: "column" }}>
      <Text
        style={{
          ...styles.bodyText,
          fontSize: 12,
          fontFamily: "Helvetica-Bold",
          marginBottom: 3,
        }}
      >
        H.Additional Information:
      </Text>
      <Text style={{ ...styles.bodyText, fontSize: 12 }}>
        <Text style={{ ...styles.bodyText, fontFamily: "Helvetica-Bold" }}>
          This notice gives our opinion, not an official Medicare decision.
        </Text>
        If you have any questions on this notice or Medicare billing, call
        <Text style={{ ...styles.bodyText, fontFamily: "Helvetica-Bold" }}>
          1-800-MEDICARE
        </Text>
        (1-800-633-4227/TTY: 1-877-486-2048). Signing below means that you have
        received and undestand this notice. You may ask to receive a copy.
      </Text>
    </View>
  );
}
